module.exports = __webpack_public_path__ + "img/金色加.66e5f2c8.svg";